module.exports = __webpack_public_path__ + "img/GreatAndBeautifulGoldenEmpress_EGM.462c7fdd.jpg";